import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { useState, useRef, useEffect } from "react";
import StationMarker from "@engineering/icons/station-marker";
import { getLocation, Runtime, useSearchSuggestions } from "@silvertours/front-entities";
import { LocationSuggest } from "../LocationSuggest";
import { SearchHistory, clearSearchHistory, getSearchHistory } from "../SearchHistory";
import { StyledInput } from "./SearchInput.styles";
var defaultProps = {
    showHistory: false
};
var SearchInput = function(param) {
    var deleteHistoryLabel = param.deleteHistoryLabel, error = param.error, fieldName = param.fieldName, historyCallback = param.historyCallback, historyHeadline = param.historyHeadline, label = param.label, noResultsText = param.noResultsText, showHistory = param.showHistory, suggestionCallback = param.suggestionCallback, value = param.value;
    var ref;
    var ref1 = useState(false), showSearchHistory = ref1[0], setShowSearchHistory = ref1[1];
    var ref2 = useState(false), showLocationSuggest = ref2[0], setShowLocationSuggest = ref2[1];
    var ref3 = useState({
        items: []
    }), searchHistory = ref3[0], setSearchHistory = ref3[1];
    useEffect(function() {
        setSearchHistory(getSearchHistory());
    }, []);
    var ref4 = useState(""), searchTerm = ref4[0], setSearchTerm = ref4[1];
    var fieldRef = useRef(null);
    var ref5 = useState(error), errorMessage = ref5[0], setErrorMessage = ref5[1];
    var ref6 = Runtime.useLocale(), language = ref6.language, market = ref6.market;
    var consumerApiSettings = Runtime.useConsumerApi().consumerApiSettings;
    var ref7 = useSearchSuggestions(language, market, consumerApiSettings), clearResults = ref7.clearResults, fetchSuggestions = ref7.fetchSuggestions, loading = ref7.loading, results = ref7.results;
    useEffect(function() {
        setErrorMessage(error);
    }, [
        error
    ]);
    var handleChange = function(inputValue) {
        setSearchTerm(inputValue);
        if (inputValue === "") {
            clearResults();
            setShowSearchHistory(true);
            setShowLocationSuggest(false);
        } else {
            setShowLocationSuggest(true);
            setShowSearchHistory(false);
            fetchSuggestions(inputValue);
        }
        suggestionCallback({});
    };
    var handleSuggestionValue = function(suggestion) {
        if (suggestion) {
            var name = "".concat(suggestion.cityName, " ").concat(suggestion.typeDisplay ? suggestion.typeDisplay : "");
            setSearchTerm(name);
            setShowLocationSuggest(false);
            clearResults();
            suggestionCallback(getLocation(suggestion));
        } else {
            handleChange(value);
        }
    };
    var handleKeyDown = function(event, handleEnterKey) {
        switch(event.key){
            case "Enter":
                if (handleEnterKey) {
                    event.preventDefault();
                    handleEnterKey();
                    setShowSearchHistory(false);
                    setShowLocationSuggest(false);
                }
                break;
            case "Escape":
                event.preventDefault();
                setShowSearchHistory(false);
                setShowLocationSuggest(false);
                break;
            default:
                break;
        }
    };
    var handleFocus = function(event) {
        if (event.target.value === "") {
            setShowSearchHistory(true);
        } else {
            fetchSuggestions(event.target.value);
            setShowLocationSuggest(true);
        }
    };
    var handleBlur = function(event) {
        var ref, ref1, ref2;
        if (!((ref = event.relatedTarget) === null || ref === void 0 ? void 0 : ref.className.includes("searchHistory"))) {
            setShowSearchHistory(false);
        }
        if (!(((ref1 = event.relatedTarget) === null || ref1 === void 0 ? void 0 : ref1.className.includes("inputCloseIcon")) || ((ref2 = event.relatedTarget) === null || ref2 === void 0 ? void 0 : ref2.className.includes("locationSuggest")))) {
            setShowLocationSuggest(false);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StyledInput, {
                ref: fieldRef,
                id: fieldName,
                type: "text",
                label: label,
                value: value || searchTerm,
                error: errorMessage,
                autoComplete: "off",
                icon: /*#__PURE__*/ _jsx(StationMarker, {}),
                iconPosition: "left",
                appearActive: true,
                hiddenLabel: true,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyDown: handleKeyDown,
                onChange: function(event) {
                    handleChange(event.target.value);
                }
            }),
            showHistory && /*#__PURE__*/ _jsx(SearchHistory, {
                hidden: ((ref = searchHistory.items) === null || ref === void 0 ? void 0 : ref.length) === 0 || !showSearchHistory,
                history: searchHistory,
                handleItemClick: function(item) {
                    if (historyCallback) {
                        historyCallback(item);
                    }
                    setShowSearchHistory(false);
                },
                handleKeyDown: handleKeyDown,
                clearSearchHistoryCallback: function() {
                    clearSearchHistory();
                    setSearchHistory(getSearchHistory());
                    setShowSearchHistory(false);
                },
                onLastElementBlur: function() {
                    setShowSearchHistory(false);
                },
                headline: historyHeadline,
                deleteLabel: deleteHistoryLabel
            }),
            showLocationSuggest && /*#__PURE__*/ _jsx(LocationSuggest, {
                connectedInputContainer: fieldRef,
                onItemClick: handleSuggestionValue,
                onLastElementBlur: function() {
                    setShowLocationSuggest(false);
                },
                results: results,
                noResultsText: noResultsText,
                loading: loading
            })
        ]
    });
};
SearchInput.defaultProps = defaultProps;
export { SearchInput };
